import { CompletionDataProps } from 'pages/CreateOrderPage/types/CompletionDataProps';
import React from 'react';
import { FullItem, Separator } from '../OrderProductSettings';
import ClientResponseProps from 'common/types/UserResponseProps';
import Button from 'common/components/Button';
import { ContentContainer } from 'pages/CreateOrderPage/styles/CreateOrderStyles';
import { CartItemContainer } from '../CartPage';
import styled from '@emotion/styled';
import { paymentList } from 'common/data/paymentList';
//<OrderInfoPage finishOrder={finishOrder} completionData={completionData} orderId={orderId} setStage={setStage} setPageType={setPageType} priceList={priceList} itemList={itemList} firm={firm} client={client} />
// type OrderCompletionPageProps = {
//   orderId: string | number;
//   setStage: React.Dispatch<React.SetStateAction<number>>;
//   client: ClientResponseProps;
//   firm: string | number;
//   priceList: string | number;
//   itemList: FullItem[];
//   setPageType: React.Dispatch<React.SetStateAction<string>>;
//   completionData: CompletionDataProps;
//   setCompletionData: React.Dispatch<React.SetStateAction<CompletionDataProps>>;
//   finishOrder: () => void;
// };
type OrderInfoPageProps = {
  finishOrder: () => void;
  completionData: CompletionDataProps;
  orderId: string | number;
  setStage: React.Dispatch<React.SetStateAction<number>>;
  setPageType: React.Dispatch<React.SetStateAction<string>>;
  priceList: string | number;
  itemList: FullItem[];
  firm: string | number;
  client: ClientResponseProps;
  firmName: string;
  priceListName: string;
};

const monthList = [
  'Січня',
  'Лютого',
  'Березня',
  'Квітня',
  'Травня',
  'Червня',
  'Липня',
  'Серпня',
  'Вересня',
  'Жовтня',
  'Листопада',
  'Грудня',
];

const CartItem = ({ item }: { item: FullItem }) => {
  return (
        <CartItemContainer>
            <div className='order-cart-item-text-wrapper'>
                {item.type === 'service' ? <><span className='order-cart-item-title'>{item.categoryName}</span>
                    {item.name && <span className='order-cart-item-subtitle'>{item.name}</span>}</> :
                    <><span className='order-cart-item-title'>{item.name}</span></>}
            </div>

            <span style={{ marginLeft:'auto' }} className='order-cart-item-price'>{item?.price?.toFixed(2) || '0.00'} ₴</span>
        </CartItemContainer>
  );
};

const InfoWrapper = styled.div`
    display:flex;
    flex-direction:column;  
    padding: 16px;
    padding-right: 8px;
    width: 389px;
    min-width: 389px;
    max-width: 389px;
    border-radius: 16px;
    border: 1px solid ${({ theme }) => theme.colors.gray};
`;

export default function OrderInfoPage({ completionData, finishOrder, itemList, setPageType, firmName, priceListName, client, orderId }: OrderInfoPageProps) {
  console.log(firmName);
  console.log(priceListName);
  console.log(completionData);
  // xx monthName
  let issueDateText = '—';
  if ( completionData.issueDate ) {
    issueDateText = `${completionData.issueDate.getDate()} ${monthList[completionData.issueDate.getMonth()]}`;
  }
  // 16:30
  let issueDateTime = '—';
  if ( completionData.issueDate ) {
    issueDateTime = `${completionData.issueDate.getHours()}:${completionData.issueDate.getMinutes()}`;
  }
  return (
        <div className='order-content-container'>
            <div className='order-cart-info-container'>
            <InfoWrapper>
                <div className='order-cart-info-wrapper u-fancy-scrollbar'>
                    <span className='medium-title'>Інформація</span>
                    <div className='order-cart-info-block'>
                        <span className='order-cart-info-title'>Про клієнта</span>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Тип особи</span>
                            <span className='new-p order-cart-info-text'>{client.companyNumber ? 'Юридична особа' : 'Фізична особа'}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>ПІБ</span>
                            <span className='new-p order-cart-info-text'>{client.companyNumber ? client.companyName : `${client.lastName} ${client.firstName[0]}. ${client.patronymic && client.patronymic[0] + '.'}`}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Країна</span>
                            <span className='new-p order-cart-info-text'>{!client.country ? '—' : client.country}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Місто</span>
                            <span className='new-p order-cart-info-text'>{!client.city ? '—' : client.city}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Прайс-лист</span>
                            <span className='new-p order-cart-info-text'>{!priceListName ? '—' : priceListName}</span>
                        </div>
                    </div>
                    <div className='order-cart-info-block'>
                        <span className='order-cart-info-title'>Про замолення</span>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>№ замовлення</span>
                            <span className='new-p order-cart-info-text'>№{orderId}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Виконавець</span>
                            <span className='new-p order-cart-info-text'>Гончаренко А.Н</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Пункт прийняття</span>
                            <span className='new-p order-cart-info-text'>{!firmName ? '—' : firmName}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Дата видачі</span>
                            <span className='new-p order-cart-info-text'>{issueDateText}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Час видачі</span>
                            <span className='new-p order-cart-info-text'>{issueDateTime}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Отримувач</span>
                            <span className='new-p order-cart-info-text'>{!completionData.client ? '—' : `${completionData.client.lastName} ${completionData.client.firstName[0]}. ${completionData.client.patronymic && completionData.client.patronymic[0] + '.'}`}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Оплата</span>
                            <span className='new-p order-cart-info-text'>{!completionData.paymentType ? '—' : paymentList[completionData.paymentType].label}</span>
                        </div>
                        <div className='order-cart-info-line-sidebar'>
                            <span className='new-p'>Комментар</span>
                            <span className='new-p order-cart-info-text'>{!completionData.comment ? '—' : completionData.comment}</span>
                        </div>
                    </div>
                </div>
            </InfoWrapper>
            <ContentContainer style={{ height: 'unset' }}>
                <div className='find-client-top-line'>
                    <span className='big-text'>
                    Замовлення
                    </span>
                    <span className='order-subtext gray-text'>
                    
                    </span>
                </div>
                <div className='order-cart-list-wrapper'>
                    <div className='order-cart-list u-fancy-scrollbar'>
                        {itemList.map((item, index) => <CartItem key={index} item={item} />)}
                    </div>
                </div>
                <div className='order-cart-info-line'>
                    <Separator />
                    <div className='order-cart-info-line-wrapper'>
                        <p className='new-p'>Бонуси</p>
                        <p className='new-p'>{(0).toFixed(2)} ₴</p>
                    </div>
                </div>
                <div className='order-cart-info-line'>
                    <Separator />
                    <div className='order-cart-info-line-wrapper'>
                        <p className='new-p'>Промокоди</p>
                        <p className='new-p'>{(0).toFixed(2)} ₴</p>
                    </div>
                </div>
                <div style={{ paddingTop:0 }} className='order-cart-price-wrapper'>
                    <Separator />
                    <div className='order-cart-price-line'>
                        <span className='order-cart-price-text'>До сплати</span>
                        <span className='order-cart-price'>{itemList.reduce((acc, item) => acc + item.price * item.count, 0).toFixed(2)} ₴</span>
                    </div>
                </div>
            </ContentContainer>
            </div>
            <div className='order-product-button-line'>
                <Button onClick={() => {setPageType('order');}} label='Повернутись' />
                <div style={{ marginTop:0 }} className='order-product-button-wrapper'>
                    <Button disabled label='У чернетку' />
                    <Button onClick={finishOrder} primary label='Готово' />
                </div>
            </div>
        </div>
  );
}